const CommonEvents = {
  NAV_LOGO_CLICKED: {
    name: "NAV_LOGO_CLICKED",
    category: "COMMON"
  },
  NAV_VIEW_PROFILE: {
    name: "NAV_VIEW_PROFILE",
    category: "COMMON"
  },
  NAV_POST_JOB_CLICKED: { name: "NAV_POST_JOB_CLICKED", category: "COMMON" },

  POST_A_JOB_CTA_CLICKED: {
    name: "POST_A_JOB_CTA_CLICKED",
    category: "COMMON"
  },
  GTM_SKIP_CLICKED: {
    name: "GTM_SKIP_CLICKED",
    category: "COMMON"
  },
  GTM_SHOWN: {
    name: "GTM_SHOWN",
    category: "COMMON"
  }
};
export default CommonEvents;
